import { useSyncExternalStore } from 'react';

/**
 * Custom hook to detect touch/coarse pointer devices.
 * Useful for adapting UI controls between drag-and-drop (desktop)
 * and button-based (mobile) interactions.
 *
 * @returns true if the device uses touch/coarse pointer input
 *
 * @example
 * const isTouchDevice = useIsTouchDevice();
 * // Show drag handles on desktop, up/down buttons on touch
 */

// Create stable references for the media query subscription
const mediaQuery = typeof window !== 'undefined'
  ? window.matchMedia('(pointer: coarse)')
  : null;

function subscribe(callback: () => void): () => void {
  mediaQuery?.addEventListener('change', callback);
  return () => mediaQuery?.removeEventListener('change', callback);
}

function getSnapshot(): boolean {
  return mediaQuery?.matches ?? false;
}

function getServerSnapshot(): boolean {
  return false; // Default to non-touch on server
}

export function useIsTouchDevice(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export default useIsTouchDevice;
